import { render, staticRenderFns } from "./WenXinTips.vue?vue&type=template&id=623c7be8&scoped=true&"
import script from "./WenXinTips.vue?vue&type=script&lang=js&"
export * from "./WenXinTips.vue?vue&type=script&lang=js&"
import style0 from "./WenXinTips.vue?vue&type=style&index=0&id=623c7be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623c7be8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623c7be8')) {
      api.createRecord('623c7be8', component.options)
    } else {
      api.reload('623c7be8', component.options)
    }
    module.hot.accept("./WenXinTips.vue?vue&type=template&id=623c7be8&scoped=true&", function () {
      api.rerender('623c7be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/publishGoods/components/WenXinTips.vue"
export default component.exports